
angular.module('bmsApp.employeeEmergencyDetail').controller('EmployeeAddEmergencyContactModalCtrl', [
	'$scope',
	'$modalInstance',
	'$ngBootbox',
	'$q',
	'notify',
	'FormOptionsSvc',
	'EmployeeEmergencyDetailSvc',
	'employeeEmergencyDetailId', function (
		$scope,
		$modalInstance,
		$ngBootbox,
		$q,
		notify,
		FormOptionsSvc,
		EmployeeEmergencyDetailSvc,
		employeeEmergencyDetailId) {

		$scope.employee_emergency_detail = {
		};

		$scope.employee_emergency_detail_id = employeeEmergencyDetailId;
		$scope.loading = true;
		$scope.processing = false;

		$scope.readEmployeeEmergencyDetail = function (id) {
			titleOptionsPromise = FormOptionsSvc.title();
			promises = [titleOptionsPromise];

			$scope.loading = true;
			if (id) {
				employeeEmergencyDetailPromise = EmployeeEmergencyDetailSvc.read(id);
				promises.push(employeeEmergencyDetailPromise);
			}
			$q.all(promises)
				.then(function (responses) {
					$scope.titleOptions = responses[0].data.options;
					if (id) {
						$scope.employee_emergency_detail = responses[1].data.employee_emergency_detail;
					}
					else {
						$scope.employee_emergency_detail = {
							employee: $scope.employee
						};
					}
					$scope.loading = false;
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit();
			},
			errorPlacement: function (error, element) {
				error.appendTo('#employee-emergency-detail-errors');
			},
			errorContainer: '#employee-emergency-detail-errors'
		};

		$scope.submit = function () {
			$scope.processing = true;
			var savePromise = $scope.employee_emergency_detail.id ? EmployeeEmergencyDetailSvc.update($scope.employee_emergency_detail.id, $scope.employee_emergency_detail) : EmployeeEmergencyDetailSvc.create($scope.employee_emergency_detail);

			savePromise
				.then(function (response) {
					modalStatus = {};
					modalStatus.success = response.data.success;
					notify({
						message: $scope.employee_emergency_detail.id ? 'Emergency details updated successfully' : 'Emergency details added successfully'
					});
					$modalInstance.close(modalStatus);
				}, function (error) {
					notify({
						message: error,
						classes: 'error'
					});
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.closeModal = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

		$scope.readEmployeeEmergencyDetail(employeeEmergencyDetailId);

	}]);
